import { AxiosResponse } from 'axios';
import { backendApiInstance } from './backendApiInstance';
import { ISignUpPayload, IValidateOtpPayload } from '../redux/auth/authSlice';

export async function updatePassword(token: string, newPassword: string, isNewUser: boolean): Promise<AxiosResponse> {
  return backendApiInstance.put('users/reset-password', {
    token,
    newPassword,
    isNewUser,
  });
}

export async function forgotPassword(email: string): Promise<AxiosResponse> {
  return backendApiInstance.post('users/send-reset-password-link', { email });
}

export async function validatePasswordResetToken(token: string): Promise<AxiosResponse> {
  return backendApiInstance.post('users/validate-password-reset-token', {
    token,
  });
}

export async function getUser(): Promise<AxiosResponse> {
  return backendApiInstance.get('users');
}
export async function getUserList(): Promise<AxiosResponse> {
  return backendApiInstance.get('users/list');
}

export interface UserUpdateData {
  avatar?: string;
  avatarContentType?: string;
  username?: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  phone?: string;
}

export async function updateUser(data: UserUpdateData): Promise<AxiosResponse> {
  return backendApiInstance.put('users', data);
}

export async function changePassword(password: string, newPassword: string): Promise<AxiosResponse> {
  return backendApiInstance.put('users/change-password', {
    password,
    newPassword,
  });
}

export async function checkPassword(password: string): Promise<AxiosResponse> {
  return backendApiInstance.put('users/check-password', { password });
}

export async function validateEmail(email: string): Promise<AxiosResponse> {
  return backendApiInstance.get('users/validate-email', { params: { email } });
}

export async function signUp(data: ISignUpPayload): Promise<AxiosResponse> {
  return backendApiInstance.post('users', data);
}

export async function validateOtp(data: IValidateOtpPayload): Promise<AxiosResponse> {
  return backendApiInstance.post('users/validate-otp', data);
}

export async function resendEmailOtp(email: string): Promise<AxiosResponse> {
  return backendApiInstance.post('users/resend-verification-code', { email });
}

export async function resendNewEmailOtp(email: string): Promise<AxiosResponse> {
  return backendApiInstance.post('users/resend-otp-code', { email });
}

export async function validateUserData(data: { [key: string]: string }): Promise<AxiosResponse> {
  return backendApiInstance.post('users/validate-user-data', data);
}

export async function validateNewEmail(data: IValidateOtpPayload): Promise<AxiosResponse> {
  return backendApiInstance.post('users/validate-new-email', data);
}

export async function getDesignations(): Promise<AxiosResponse> {
  return backendApiInstance.get('users/designations');
}

export async function createOrUpdatePin(pin: string | null): Promise<AxiosResponse> {
  return backendApiInstance.post('users/set-pin', { pin });
}

export async function updateUserPin(newPin: string): Promise<AxiosResponse> {
  return backendApiInstance.put('users/pin', {
    newPin,
  });
}
